import React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from '../../utils/fvAxios';
import apiinfo from "../../utils/base-uri.json";
import { ToastContainer, toast } from "react-toastify";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";



export default function Loginhelp(props) {


  const [Dis, setDis] = React.useState(false);
  const [Name, setName] = React.useState("");
  const [Email, setEmail] = React.useState("");
  const [EmailErr, setEmailErr] = React.useState("");
  const [SubjectType, setSubjectType] = React.useState("1");
  const [Comments, setComments] = React.useState("");

  const [PhoneNumber, setPhoneNumber] = React.useState("");
  const [PhoneNumberError, setPhoneNumberError] = React.useState("");


  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');
    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setPhoneNumber('');
        setPhoneNumberError(true);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setPhoneNumber(formattedInput);
        setPhoneNumberError(false);
      } else {
        setPhoneNumber(numericInput);
        setPhoneNumberError(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setPhoneNumber(numericInput.slice(0, 9));
      setPhoneNumberError(true);
    }
  };

  // const ChangePhone = (ans) => {
  //   let regPhone = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  //   if (ans == "") {
  //     setPhoneNumber(ans);
  //     setPhoneNumberError("");
  //   } else if (!regPhone.test(ans)) {
  //     setPhoneNumber(ans);
  //     setPhoneNumberError("Invalid phone number");
  //   } else {
  //     setPhoneNumber(ans);
  //     setPhoneNumberError("");
  //   }
  // };



  const ChangeEmail = (ans) => {
    let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i;
    if (ans == "") {
      setEmail(ans);
      setEmailErr("");
    } else if (!regEmail.test(ans)) {
      setEmail(ans);
      setEmailErr("Please check email format");
    } else {
      setEmail(ans);
      setEmailErr("");
    }
  };

  const Close = () => {
    props.close(true);
  }

  const onSubmit = () => {
    setDis(true);
    if (Name != "" && Email != "" && PhoneNumber != "" && Comments != "" && EmailErr == "" && PhoneNumberError == "") {
      const item = {
        name: Name,
        phoneNumber: PhoneNumber,
        email: Email,
        subjectType: SubjectType == 1 ? "Wrong Password" : "Another Issues",
        comments: Comments
      }
      axios.post("Login/NeedLoginHelp", item)
        .then(res => {
          if (res?.data?.responseCode == "100") {
            toast.success("Your request has been successfully sent. We will contact you as soon as possible.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            Close();
            setDis(false);
          }
          else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setDis(false);
          }

        }).catch(res => {
          toast.error("Server brake", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          Close();
          setDis(false);
        })
    } else {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setDis(false);
    }

  }

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={Dis}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogContent>
        <ToastContainer />
        <span className='username-label' sx={{ fontWeight: 500, fontSize: 14 }}>Name<span className="red-color">*</span></span>
        <TextField
          inputProps={{ className: "login-user" }}
          placeholder='Name'
          value={Name}
          onChange={(e) => setName(e?.target?.value)}
        />
        <br />

        <span className='username-label margin-top-10'>Phone number<span className="red-color">*</span></span>
        <TextField
          inputProps={{ className: "login-user" }}
          placeholder="Phone number"
          value={PhoneNumber}
          onInput={handleInputChange}
          error={PhoneNumberError}
          helperText={PhoneNumberError ? 'Invalid phone number format. Use (xxx) xxx-xxxx' : ''}
        />

        <span className='username-label margin-top-10'>Email<span className="red-color">*</span></span>
        <TextField
          inputProps={{ className: "login-user" }}
          placeholder='Email'
          value={Email}
          onChange={(e) => ChangeEmail(e?.target?.value)}
        /><br />
        <span className="red-color">{EmailErr}</span>

        <span className='username-label margin-top-10'>Subject Type<span className="red-color">*</span></span>
        <Select
          inputProps={{ className: "select-option" }}
          value={SubjectType}
          onChange={(e) => setSubjectType(e?.target?.value)}
          placeholder='SubjectType'>
          <MenuItem value={"1"}>Wrong Password</MenuItem>
          <MenuItem value={"2"}>Another Issues</MenuItem>
        </Select>

        <span className='username-label margin-top-10'>Comments<span className="red-color">*</span></span>
        <TextareaAutosize
          maxRows={4}
          aria-label="maximum height"
          color="secondary"
          placeholder='Comments'
          style={{ width: "380px", height: "128px" }}
          // inputProps={{ className: "login-user-comment" }}
          value={Comments}
          onChange={(e) => setComments(e?.target?.value)}
        />
      </DialogContent >
      <DialogActions>
        <div className="login-help__buttonContainer">
          <Button variant="contained" className="login-help-button-cancel" sx={{ textTransform: "capitalize" }} onClick={Close}>Cancel</Button>
          <Button variant="contained" disabled={Dis} className="login-button-request" sx={{ textTransform: "capitalize" }} onClick={onSubmit}>Send Request</Button>
        </div>

      </DialogActions>

      {/* {error && <div className="mt-1" style={{ color: "red", textAlign: "center" }}>{error}</div>} */}

    </>
  )
}
